import React, { useState } from "react";
import { Mosaic, MosaicWindow } from "react-mosaic-component";
import "react-mosaic-component/react-mosaic-component.css";
import LiveHighChart from "./Chart";
import { useLayout } from "../Context/LayoutContext";

// import { v4 as uuidv4 } from "uuid";

// const createChartTile = () => uuidv4();


// Simple unique ID generator
function createChartTile(prefix = "chart") {
    return prefix + "_" + Math.random().toString(36).substr(2, 9);
}

const ELEMENTS = {
    chart: "Chart1",
    chart2: "Chart2",
    chart3: "Chart3",
};


const layouts = [

    {
        key: "1c", // 1 chart layout
        layout: createChartTile(), // single tile
    },
    {
        key: "2c-l1", // 2 chart layout 1
        layout: {
            direction: "row", // horizontal split
            first: createChartTile(),   // must match ELEMENTS key
            second: createChartTile(),
        },
    },
    {
        key: "2c-l2",  // 2 chart layout 2
        layout: {
            direction: "column", // vertical split
            first: createChartTile(),
            second: createChartTile(),
        },
    },
    {
        key: "3c-l1",  // 3 chart layout 1
        layout: {
            direction: "column", // vertical split
            first: createChartTile(),
            second: {
                direction: "row",
                first: createChartTile(),
                second: createChartTile(),
            },
        },
    },
    {
        key: "3c-l2",  // 3 chart layout 1
        layout: {
            direction: "column", // vertical split
            first: {
                direction: "row",
                first: createChartTile(),
                second: createChartTile(),
            },
            second: createChartTile(),

        },
    },

    {
        key: "3c-l3",  // 3 chart layout 1
        layout: {
            direction: "row", // vertical split
            first: createChartTile(),
            second: {
                direction: "column",
                first: createChartTile(),
                second: createChartTile(),
            },
        },
    },
    {
        key: "3c-l4",  // 3 chart layout 1
        layout: {
            direction: "row", // vertical split
            first: {
                direction: "column",
                first: createChartTile(),
                second: createChartTile(),
            },
            second: createChartTile(),

        },
    },
    {
        key: "3c-l5",
        layout: {
            direction: "row", // horizontal split (side by side)
            first: createChartTile(), // first column
            weight: 20,
            second: {
                direction: "row", // second split for second & third column
                first: createChartTile(), // second column
                second: createChartTile(), // third column
            },
        },
    },
    {
        key: "4c-l1",
        layout: {
            direction: "column", // horizontal split (side by side)
            first: {
                direction: "row", // second split for second & third column
                first: createChartTile(), // second column
                second: createChartTile(), // third column
            },
            second: {
                direction: "row", // second split for second & third column
                first: createChartTile(), // second column
                second: createChartTile(), // third column
            },
        },
    },
    {
        key: "4c-l2",
        layout: {
            direction: "column", // vertical split
            first: {
                direction: "row", // top row split
                first: createChartTile(),
                second: {
                    direction: "row", // split again for 2nd & 3rd
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
            second: createChartTile(), // bottom single chart
        },
    },
    {
        key: "4c-l3",
        layout: {
            direction: "column", // vertical split
            first: createChartTile(), // bottom single chart

            second: {
                direction: "row", // top row split
                first: createChartTile(),
                second: {
                    direction: "row", // split again for 2nd & 3rd
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
        },
    },
    {
        key: "4c-l4",
        layout: {
            direction: "row", // main split left vs right
            first: createChartTile(), // left column, 1 chart
            second: {
                direction: "column", // right side split into 3
                first: createChartTile(),
                second: {
                    direction: "column", // nest again for 2nd & 3rd chart
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
        },
    },
    {
        key: "4c-l5",
        layout: {
            direction: "row", // main split left vs right
            first: {
                direction: "column", // right side split into 3
                first: createChartTile(),
                second: {
                    direction: "column", // nest again for 2nd & 3rd chart
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
            second: createChartTile(), // left column, 1 chart

        },
    },
    {
        key: "mc-l1",
        layout: {
            direction: "column", // vertical split
            first: createChartTile(), // top single chart
            second: {
                direction: "row", // bottom row with 4 charts
                first: createChartTile(),
                second: {
                    direction: "row",
                    first: createChartTile(),
                    second: {
                        direction: "row",
                        first: createChartTile(),
                        second: createChartTile(),
                    },
                },
            },
        },
    },
    {
        key: "mc-l2",
        layout: {
            direction: "row", // main split left vs right
            first: {
                direction: "column", // right side split into 3
                first: createChartTile(),
                second: {
                    direction: "column", // nest again for 2nd & 3rd chart
                    first: createChartTile(),
                    second: {
                        direction: "column", // nest again for 2nd & 3rd chart
                        first: createChartTile(),
                        second: createChartTile(),
                    },
                },
            },
            second: createChartTile(), // left column, 1 chart

        },
    },
    {
        key: "mc-l3",
        layout: {
            direction: "row", // main split left vs right
            first: createChartTile(), // left column, 1 chart

            second: {
                direction: "column", // right side split into 3
                first: createChartTile(),
                second: {
                    direction: "column", // nest again for 2nd & 3rd chart
                    first: createChartTile(),
                    second: {
                        direction: "column", // nest again for 2nd & 3rd chart
                        first: createChartTile(),
                        second: createChartTile(),
                    },
                },
            },

        },
    },
    {
        key: "mc-l4",
        layout: {
            direction: "column", // 2 rows
            first: {
                direction: "row", // first row
                first: createChartTile(), // left big chart
                second: {
                    direction: "column", // right side stacked
                    first: createChartTile(), // top right
                    second: createChartTile(), // bottom right
                },
            },
            second: {
                direction: "row", // second row 3 charts in a row
                first: createChartTile(),
                second: {
                    direction: "row",
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
        },
    },
    {
        key: "mc-l5",
        layout: {
            direction: "column", // 2 rows
            first: {
                direction: "row", // top row
                first: createChartTile(),
                second: {
                    direction: "row",
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
            second: {
                direction: "row", // bottom row
                first: createChartTile(),
                second: {
                    direction: "row",
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
        },
    },

    {
        key: "mc-l6",
        layout: {
            direction: "column", // 2 rows

            first: {
                direction: "row", // second row
                first: createChartTile(), // left full chart
                second: {
                    direction: "column", // right side stacked
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
            second: {
                direction: "row", // first row
                first: createChartTile(), // left full chart
                second: {
                    direction: "column", // right side stacked
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
        },
    },
    {
        key: "mc-l7",
        layout: {
            direction: "column", // 2 rows
            first: {
                direction: "row", // first row
                first: {
                    direction: "column", // right side stacked
                    first: createChartTile(),
                    second: createChartTile(),
                },
                second: createChartTile(), // left full chart

            },
            second: {
                direction: "row", // first row
                first: {
                    direction: "column", // right side stacked
                    first: createChartTile(),
                    second: createChartTile(),
                },
                second: createChartTile(), // left full chart

            },
        },
    },
    {
        key: "mc-l8",
        layout: {
            direction: "column", // vertical split
            first: {
                direction: "row", // top row split
                first: createChartTile(),
                second: createChartTile(),

            },

            second: {
                direction: "row", // top row split
                first: createChartTile(),
                second: {
                    direction: "row", // split again for 2nd & 3rd
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
        },
    },
    {
        key: "mc-l9",
        layout: {
            direction: "column", // vertical split

            first: {
                direction: "row", // top row split
                first: createChartTile(),
                second: {
                    direction: "row", // split again for 2nd & 3rd
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
            second: {
                direction: "row", // top row split
                first: createChartTile(),
                second: createChartTile(),

            },

        },
    },
    {
        key: "mc-l10",
        layout: {
            direction: "column", // 3 rows
            first: {
                direction: "row", // row 1
                first: createChartTile(),
                second: {
                    direction: "row",
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
            second: {
                direction: "column", // rows 2 & 3
                first: {
                    direction: "row", // row 2
                    first: createChartTile(),
                    second: {
                        direction: "row",
                        first: createChartTile(),
                        second: createChartTile(),
                    },
                },
                second: {
                    direction: "row", // row 3
                    first: createChartTile(),
                    second: {
                        direction: "row",
                        first: createChartTile(),
                        second: createChartTile(),
                    },
                },
            },
        },
    }


];




export default function TradeLayout() {

    const [value, setValue] = useState(layouts[10].layout);
    const { currentLayout, switchLayout, setCurrentLayout } = useLayout();

    return (
        <div style={{ flex: 1 }}>
            <Mosaic
                renderTile={(id, path) => (
                    <MosaicWindow
                        path={path}
                        title={"Chart"}
                        renderToolbar={(props) => (
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "center",
                                    width: "100%",
                                    height: "100%",
                                    background: "transparent",
                                    padding: "4px 8px",
                                }}
                            >
                                {/* Close Button only */}
                                {props.connectDragSource(
                                    <span
                                        style={{
                                            cursor: "pointer",
                                            color: "red",
                                            fontWeight: "bold",
                                            marginRight: "8px",
                                            // display: "none"
                                        }}
                                        onClick={props.onClose}
                                    >
                                        ✖
                                    </span>
                                )}

                            </div>
                        )}
                    >
                        <div style={{ padding: 10, background: "transparent", color: "#fff", height: '100%', position: 'relative' }}>
                            {/* {ELEMENTS[id]} Content */}
                            <LiveHighChart chartId={id} />
                        </div>
                    </MosaicWindow>
                )}
                // value={value}
                // onChange={(newNode) => setValue(newNode)}
                value={currentLayout}
                onChange={(newNode) => setCurrentLayout(newNode)}
            />
        </div>
    );
}
